import AppClient from './AppClient';

const App = {
    Client: AppClient,
}

export default App;